import StaticSchema from '@/components/Schema/StaticSchema';
import { Section } from '@/components/Section/Section';
import SkipToContent from '@/components/SkipToContent/SkipToContent';
import type { StandardPageContent } from '@/contentful';
import type { userLocationInterface } from '@/hooks/geo';
import FooterComponent from '../Layout/Footer/Footer';
import HeaderComponent from '../Layout/Header/Header';

interface Props extends userLocationInterface {
  content: StandardPageContent;
}

export default function StandardPage({
  content: {
    fields: { header, footer, sections },
  },
  userLocation,
  setUserLocation,
}: Props) {
  return (
    <>
      <StaticSchema />
      <SkipToContent href='#main' />
      <HeaderComponent
        header={header}
        userLocation={userLocation}
        setUserLocation={setUserLocation}
      />
      {/** biome-ignore lint/correctness/useUniqueElementIds: Automated migration to Biome */}
      <main style={{ backgroundColor: 'black' }} id='main'>
        {sections.map((section, index) => (
          <Section
            key={section.sys.id}
            section={section}
            userLocation={userLocation}
            sectionPosition={index}
          />
        ))}
      </main>
      <FooterComponent
        footer={footer}
        userLocation={userLocation}
        setUserLocation={setUserLocation}
      />
    </>
  );
}
